import Main from '@/views/common/main'
// 风控
export default [
    //'风控管理'
    {
        path: '/appdata',
        name: 'appdata',
        meta: {
            icon: 'ios-apps',
            title: '盘口数据'
        },
        component: Main,
        children: [
            // 盘口数据统计
            {
                path: 'dataRecord',
                name: 'riskment_dataRecord',
                meta: { title: '盘口数据统计' },
                component: () => import('@/views/appdata/dataRecord.vue')
            },
            // 子游戏数据统计
            {
                path: 'subGameData',
                name: 'riskment_subGameData',
                meta: { title: '子游戏数据统计' },
                component: () => import('@/views/appdata/subGameData.vue')
            },
            //子游戏趋势数据
            {
                path: 'subGameTrend',
                name: 'riskment_subGameTrend',
                meta: { title: '子游戏趋势数据' },
                component: () => import('@/views/appdata/subGameTrend.vue')
            },
            //注册用户查询
            {
                path: 'userList',
                name: 'appdata_userList',
                meta: { title: '注册用户查询' },
                component: () => import('@/views/appdata/userList.vue')
            },
            //盘口流水查询
            {
                path: 'AppPointRecord',
                name: 'appdata_AppPointRecord',
                meta: { title: '盘口流水查询' },
                component: () => import('@/views/appdata/AppPointRecord.vue')
            },
            //用户流水单号查询
            {
                path: 'UserPointRecord',
                name: 'appdata_UserPointRecord',
                meta: { title: '用户流水单号查询' },
                component: () => import('@/views/appdata/UserPointRecord.vue')
            },
            //子游戏房间数据
            {
                path: 'subGameRoom',
                name: 'appdata_subGameRoom',
                meta: { title: '子游戏房间数据' },
                component: () => import('@/views/appdata/subGameRoom.vue')
            },
            {
                path: 'handleOnlinePlayData',
                name: 'riskment_handleOnlinePlayData',
                meta: { title: '盘口在线在玩数据' },
                component: () => import('@r/handleOnlinePlayData.vue')
            },
            //用户地区分布统计
            {
                path: 'areadata',
                name: 'appdata_areadata',
                meta: { title: '用户地区分布统计' },
                component: () => import('@/views/appdata/areadata.vue')
            },
            {
                path: 'rechargeData',
                name: 'appdata_rechargeData',
                meta: { title: '支付通道订单统计' },
                component: () => import('@/views/appdata/rechargeData.vue')
            }
        ]
    }
]
// 数据报表
